import { useQuery } from "@tanstack/react-query";
import { getSecureUser } from "@/utils/secureStorage";
import { useLoggedInCompany } from "./useCompanyQueries";
import { useDepartmentData } from "./useDepartmentData";

interface DefaultConversationPartner {
  id: string;
  displayName: string;
  profilePhoto?: string;
  role: string;
  type?: "User" | "Company";
}

export const useDefaultConversation = () => {
  const user = getSecureUser();
  const { data: companyData, isLoading: companyLoading } = useLoggedInCompany();
  const { data: departmentData } = useDepartmentData(user?.departmentId || "", user?.role === "department_admin");

  return useQuery({
    queryKey: ["defaultConversation", user?.id, user?.role, companyData?.data?.document?._id],
    queryFn: async (): Promise<DefaultConversationPartner | null> => {
      if (!user) return null;

        // For users and department admins, default to the Company
        if (user.role === "employee" || user.role === "department_admin") {
          // Use the companyId from user data to create default company partner
          if (user.companyId) {
            return {
              id: user.companyId,
              displayName: "Company",
              profilePhoto: undefined,
              role: "company",
              type: "Company"
            };
          }
        }

      return null;
    },
    enabled: !!user && !companyLoading,
    // Use global defaults for staleTime
  });
};
